import RestStore from "@shared/svelte/Stores/RestStore";

export default function RetailerStore(initial: any, getUrl = null, updateUrl = null) {
  const store = RestStore(initial, "/api/onboarding/retailer", "retailer", "", getUrl, updateUrl);
  return store;
}
